import React from "react";
import PropTypes from "prop-types";
import { TvDiv } from "@trustvid/design-system";
import LoginMarketing from "./LoginMarketing";
import AuthPageFooter from "./AuthPageFooter";
import { useAuthPageBodyLock } from "./useAuthPageBodyLock";

/**
 * Shared shell for login and split auth pages (marketing column + form column + footer).
 */
const LoginPageLayout = ({
  pageTestId = "login-page",
  pageHeading,
  bodyCanvas = null,
  formAccent = true,
  formColumnClassName = "tv-login-page__form-column tv-login-page__form-column--full position-relative d-flex flex-column",
  hideFormBrandOnMobile = false,
  children,
}) => {
  useAuthPageBodyLock();

  return (
    <TvDiv className="tv-login-page d-flex flex-column" data-testid={pageTestId}>
      <TvDiv className="tv-login-page__body flex-grow-1 d-flex flex-column flex-lg-row">
        {bodyCanvas}

        <LoginMarketing variant="full" pageHeading={pageHeading} className="d-none d-lg-flex" />

        <TvDiv className={formColumnClassName} data-testid="login-form-column">
          {formAccent ? <TvDiv className="tv-login-page__form-accent" aria-hidden="true" /> : null}

          <LoginMarketing
            variant="compact-hero"
            pageHeading={pageHeading}
            className="d-lg-none tv-login-page__form-marketing-hero"
          />

          <TvDiv
            className={`tv-login-page__form-main flex-grow-1 d-flex flex-column${hideFormBrandOnMobile ? " tv-login-page__form-main--hide-brand-mobile" : ""}`}
          >
            {children}
          </TvDiv>

          <LoginMarketing variant="compact-cards" className="d-lg-none tv-login-page__form-marketing-cards" />
        </TvDiv>
      </TvDiv>

      <AuthPageFooter />
    </TvDiv>
  );
};

LoginPageLayout.propTypes = {
  pageTestId: PropTypes.string,
  pageHeading: PropTypes.string,
  bodyCanvas: PropTypes.node,
  formAccent: PropTypes.bool,
  formColumnClassName: PropTypes.string,
  hideFormBrandOnMobile: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default LoginPageLayout;
